export const IMAGE_GATEWAY_URL = import.meta.env.VITE_IMAGE_GATEWAY_URL || 'https://images.scan2order.shop';
